import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a24e90b4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a24e90b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24e90b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a24e90b4')) {
      api.createRecord('a24e90b4', component.options)
    } else {
      api.reload('a24e90b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a24e90b4&scoped=true&", function () {
      api.rerender('a24e90b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/index.vue"
export default component.exports